import type * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { GridItem } from '@xing-com/grid';
import {
  IconRocket,
  IconReaction,
  IconCompass,
  IconVCard,
  IconQualification,
  IconVOMP,
} from '@xing-com/icons';

import { translationVariables } from '../../constants';
import type { ProductType } from '../../typings/types';

import {
  StyledCard,
  StyledIconPadding,
  StyledHeadline,
  StyledBodyCopy,
  StyledBenefitsGridContainer,
} from './benefit-card.styles';
import type { ProductBenefitsProps } from './product-benefits';

type CardItemProps = {
  product: ProductType;
  position: number;
};

const IconProps = {
  width: 24,
  height: 24,
};

const CardItem: React.FC<CardItemProps> = ({ product, position }) => {
  let icon;
  let headlineValue;
  const headlineText = `UPSELL_LOGGED_OUT_PAGE_PRODUCTS_${product.toLocaleUpperCase()}_BENEFIT_HEADER_${position}`;
  const bodyText = `UPSELL_LOGGED_OUT_PAGE_PRODUCTS_${product.toLocaleUpperCase()}_BENEFIT_SUBHEADER_${position}`;

  switch (position) {
    case 1:
      icon =
        product === 'projobs' ? (
          <IconRocket {...IconProps} />
        ) : (
          <IconVCard {...IconProps} />
        );
      headlineValue =
        translationVariables[
          'UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_HEADER_1'
        ].values;
      break;
    case 2:
      icon =
        product === 'projobs' ? (
          <IconReaction {...IconProps} />
        ) : (
          <IconQualification {...IconProps} />
        );
      break;
    case 3:
      icon =
        product === 'projobs' ? (
          <IconCompass {...IconProps} />
        ) : (
          <IconVOMP {...IconProps} />
        );
      break;
  }

  return (
    <StyledCard product={product}>
      <StyledIconPadding product={product}>{icon}</StyledIconPadding>
      <StyledHeadline product={product} noMargin>
        <FormattedMessage id={headlineText} values={headlineValue} />
      </StyledHeadline>
      <StyledBodyCopy product={product} noMargin>
        <FormattedMessage id={bodyText} />
      </StyledBodyCopy>
    </StyledCard>
  );
};

export const BenefitCardList: React.FC<ProductBenefitsProps> = ({
  product,
}) => {
  return (
    <StyledBenefitsGridContainer variant="FullSize">
      <GridItem span={12} spanMedium={4}>
        <CardItem product={product} position={1} />
      </GridItem>
      <GridItem span={12} spanMedium={4}>
        <CardItem product={product} position={2} />
      </GridItem>
      <GridItem span={12} spanMedium={4}>
        <CardItem product={product} position={3} />
      </GridItem>
    </StyledBenefitsGridContainer>
  );
};
